import { api } from './index';

const BASE_PATH = '/api/internal/tax_settings';

// The company's e-invoicing setup as the settings page sees it: its choices,
// its account at the provider and what is ready to issue. Whether it issues at
// all is Kuido's switch; a company only reaches this page once it is on.
export interface TaxProfileChoices {
  taxCategory: string;
  pricesIncludeTax: boolean;
  documentKind: string;
}

export interface TaxProfileSummary extends TaxProfileChoices {
  persisted: boolean;
  countryCode: string | null;
  currency: string | null;
  taxCategories: string[];
  documentKinds: string[];
}

export type CredentialStatus = 'valid' | 'invalid' | 'expired' | 'missing' | null;

export interface TaxAccountSummary {
  id: number;
  connected: boolean;
  credentialStatus: CredentialStatus;
  certificate: boolean;
  connectedAt: string | null;
  active: boolean;
  registeredName: string | null;
  webhook: { status: 'registered' | 'not_configured' | 'failed'; error?: string } | null;
}

export interface TaxSettings {
  company: { name: string; taxId: string | null; taxIdLabel: string | null };
  profile: TaxProfileSummary;
  account: TaxAccountSummary | null;
  ready: { invoice: boolean; receipt: boolean };
}

// The signer's authority credentials: relayed to the provider once, never kept.
// Which provider that is never appears here — the server picks it.
export interface EnrolmentForm {
  authorityUserTaxId: string;
  authorityPassword: string;
  certificatePassword: string;
}

export const taxSettingsApi = {
  show(): Promise<TaxSettings> {
    return api({
      method: 'get',
      url: BASE_PATH,
    }).then(response => response.data.taxSettings);
  },
  update(profile: TaxProfileChoices): Promise<TaxSettings> {
    return api({
      method: 'patch',
      url: BASE_PATH,
      data: { profile },
    }).then(response => response.data.taxSettings);
  },
  enroll(form: EnrolmentForm): Promise<TaxSettings> {
    return api({
      method: 'post',
      url: `${BASE_PATH}/enroll`,
      data: form,
    }).then(response => response.data.taxSettings);
  },
  refresh(): Promise<TaxSettings> {
    return api({
      method: 'post',
      url: `${BASE_PATH}/refresh`,
    }).then(response => response.data.taxSettings);
  },
};
